import { Fragment } from "react"

import { define, prop } from "@/components/builder/utils"

import BasePreview from "../../base"
import { useTCPAQuestion } from "../context"

function MidpathTCPAQuestionTitlePreview(props) {
  const tcpaquestion = useTCPAQuestion()

  if (!tcpaquestion) return null

  const { question } = tcpaquestion
  return <BasePreview {...props}>
    <div className="tcpa-question">{question || 'No question text'}</div>
  </BasePreview>
}

export default define('tcpa-question', MidpathTCPAQuestionTitlePreview, Fragment)
  .shared(prop.share('MidpathTCPAQuestionTitle', 'tcpa-question'), { prefix: false })
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .defaultProps({
    textAlign: { horizontal: "center" },
    fontSize: "20px",
    fontWeight: "font-bold",
  })
  .build()
